export default __webpack_public_path__ + "static/media/avatarMan.13dbe3b4.jfif";